export const GET_ATTR_DATA = "GET_ATTR_DATA";
export const GET_ATTR_DATA_SUCCESS = "GET_ATTR_DATA_SUCCESS";
export const GET_ATTR_DATA_FAIL = "GET_ATTR_DATA_FAIL";
